module.exports = __webpack_public_path__ + "media/components/page-payment/stripe-a05557ad9af6f9d6c3020cff3fa55acf.svg";